// src/components/ForgotPasswordModal.js
//this file is a React component for a modal that allows users to request a password reset link by entering their email address. It includes input validation and a button to send the reset link.`
// The component uses local state to manage the email input and handles the send action by calling a parent function passed as a prop. The modal also includes a close button to return to the login screen.
import React, { useState } from 'react';
import styles from './ForgotPassword.module.css';

const ForgotPasswordModal = ({ onClose, onSend }) => {
  const [email, setEmail] = useState('');

  const handleSend = () => {
    onSend(email); // Trigger parent handler
  };

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <h2 className={styles.title}>Forgot Password</h2>
        <p className={styles.subtitle}>
          Enter your email address and we'll send you a link to reset your password
        </p>

        <label className={styles.label}>Email</label>
        <input
          type="email"
          className={styles.input}
          placeholder="name@example.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <button className={styles.sendButton} onClick={handleSend}>
          Send Reset Link
        </button>

        <button className={styles.backButton} onClick={onClose}>
          ← Back to Login
        </button>
      </div>
    </div>
  );
};

export default ForgotPasswordModal;
